module.exports = __webpack_public_path__ + "img/ETH.7ca03335.svg";